import { StyleSheet, View } from 'react-native';
import SectionDivider from 'shared/components/vxl/divider/SectionDivider/SectionDivider';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import BodySmText from 'shared/components/vxl/typography/primary/body/BodySmText';
import BodyXSText from 'shared/components/vxl/typography/primary/body/BodyXSText';
import theme from 'shared/styles/theme';

export interface PaymentScheduleTimelineItem {
  id: string;
  label: string;
}

interface PaymentScheduleTimelineProps {
  title?: string;
  description?: string;
  items: PaymentScheduleTimelineItem[];
  disclosureText?: string;
}

const PaymentScheduleTimeline = ({
  title,
  description,
  items,
  disclosureText,
}: PaymentScheduleTimelineProps) => {
  return (
    <>
      {title ? <SectionDivider labelText={title} /> : null}
      {description ? (
        <BodyBaseText numberOfLines={0} style={styles.description}>
          {description}
        </BodyBaseText>
      ) : null}
      <View style={styles.scheduleList}>
        {items.map((item, index) => {
          const hasConnector = index < items.length - 1;

          return (
            <View key={item.id} style={styles.scheduleItem}>
              <View style={styles.timelineIndicator}>
                <View style={styles.timelineDot} />
                {hasConnector ? (
                  <View
                    testID="payment-schedule-timeline-connector"
                    style={styles.timelineLine}
                  />
                ) : null}
              </View>
              <BodySmText style={styles.scheduleText} numberOfLines={0}>
                {item.label}
              </BodySmText>
            </View>
          );
        })}
      </View>
      {disclosureText ? (
        <BodyXSText numberOfLines={0} style={styles.disclosureText}>
          {disclosureText}
        </BodyXSText>
      ) : null}
    </>
  );
};

const styles = StyleSheet.create({
  description: {
    paddingHorizontal: theme.spacing.m,
    paddingTop: theme.spacing.s,
  },
  disclosureText: {
    paddingHorizontal: theme.spacing.m,
    paddingBottom: theme.spacing.m,
  },
  scheduleItem: {
    alignItems: 'flex-start',
    flexDirection: 'row',
    minHeight: 36,
  },
  scheduleList: {
    paddingHorizontal: theme.spacing.m,
    paddingTop: theme.spacing.m,
  },
  scheduleText: {
    marginLeft: theme.spacing.s,
    marginTop: -3,
    paddingTop: 0,
  },
  timelineDot: {
    borderColor: theme.color.text.tertiary,
    borderRadius: '50%',
    borderWidth: 1,
    height: 14,
    width: 14,
  },
  timelineIndicator: {
    alignItems: 'center',
    height: '100%',
    width: 24,
  },
  timelineLine: {
    borderColor: theme.color.text.tertiary,
    borderStyle: 'dashed',
    borderWidth: 1,
    flex: 1,
  },
});

export default PaymentScheduleTimeline;
